export default class OfficeGlobalDataItem {
  constructor(item) {
    if (item === undefined) {
      this.vocazillaCostPerMinute = '';
      this.ivrfeeCostPerEval = '';
      this.icrfeeCostPerEval = '';
      this.endOfMonthCutoffDay = '';
      this.ddprejectSurcharge = '';
      this.currentYRMO = '';
      this.allowInvoiceFinalization = '';
      this.allowEndOfMonthAutomation = '';
      this.yrmoCutoffDate = '';
      this.maximumOpportunityDuration = '';
      this.defaultInvoiceInterestRate = '';
      this.evaluatorStatementDelay = '';
      this.lateFeeGracePeriodInDays = '';
      this.maximumIntervalInMonthsBetweenOpportunityEndDateAndProjectEndDate = '';
      this.globalUserDeactivationDaysLimit = '';
      return;
    }
    this.vocazillaCostPerMinute = item.vocazillaCostPerMinute;
    this.ivrfeeCostPerEval = item.ivrfeeCostPerEval;
    this.icrfeeCostPerEval = item.icrfeeCostPerEval;
    this.endOfMonthCutoffDay = item.endOfMonthCutoffDay;
    this.ddprejectSurcharge = item.ddprejectSurcharge;
    this.currentYRMO = item.currentYRMO;
    this.allowInvoiceFinalization = item.allowInvoiceFinalization;
    this.allowEndOfMonthAutomation = item.allowEndOfMonthAutomation;
    this.yrmoCutoffDate = item.yrmoCutoffDate;
    this.maximumOpportunityDuration = item.maximumOpportunityDuration;
    this.defaultInvoiceInterestRate = item.defaultInvoiceInterestRate;
    this.evaluatorStatementDelay = item.evaluatorStatementDelay;
    this.lateFeeGracePeriodInDays = item.lateFeeGracePeriodInDays;
    this.maximumIntervalInMonthsBetweenOpportunityEndDateAndProjectEndDate =
      item.maximumIntervalInMonthsBetweenOpportunityEndDateAndProjectEndDate;
    this.globalUserDeactivationDaysLimit = item.globalUserDeactivationDaysLimit;
  }
}
